export default __webpack_public_path__ + "static/6912-39a5cdf450327ff36d3fbdb8ad618536.jpg";